import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Compose Tailwind class strings, deduplicating conflicting utilities.
 * Standard shadcn-style pattern. Used in every component below.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
